import { ContactAddress } from './contact-address-item.model';
import { Phone } from './phone.model';
import { OrganizationItem } from './organization-item.model';

export class ContactItem {
  SiteId: any;
  constructor(
    public Prefix: string,
    public PrefixTypeId: number,
    public partyId: string,
    public firstName: string,
    public lastName: string,
    public MiddleName: string,
    public Suffix: string,
    public contactId: string,
    public StartDate: Date,
    public email: string,
    public Title: string,
    public Comments: string,
    public addresses: ContactAddress[],
    public phones: Phone[],
    public externalPartyId: string,
    public contactRoleId: number,
    public contactRoleName: number,
    public person?: ContactItem,
    public organization?: OrganizationItem,
    public ApplicationToken?: string,
    public EndDate?: Date,
    public OrganizationName?: string,
    public OrganizationType?: string,
    public externalContactId?: string
  ) {}
}

